// removed by extract-text-webpack-plugin
module.exports = {"proposalEditor":"_3dLODA","proposalId":"_3jrW-w","hint":"EfTGUl","error":"_1217ZY","buttonGroup":"_21MQhx","voteButton":"_dAjIh","proposalNoteHeading":"_34xx2Z"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ProposalEditor/proposalEditor-style.css
// module id = 103
// module chunks = 0